<template>
	<div>
		<el-button :size="bottonObj.size"
			:type="bottonObj.type"
			:plain="bottonObj.plain"
			:round="bottonObj.round"
			:circle="bottonObj.circle"
			:loading="loading"
			:disabled="bottonObj.disabled"
			:icon="bottonObj.icon"
			@click="download">{{bottonObj.text || '下载'}}</el-button>
	</div>
</template>

<script>
	import main from './main.js';
	export default {
		name: 'z-download',
		props: {
			bottonObj: {
				type: Object,
				default: () => {
					return {}
				}
			},
			fileName: {
				type: String,
				required: true
			},
			params: {
				type: Object,
				default: () => {
					return {}
				}
			},
			requestType: {
				type: String,
			}
		},
		data() {
			return {
				loading: false,

			}
		},
		methods: {
			async download() {
				this.loading = true;
				let res = await main(this.fileName, this.params, this.requestType);
				if (res) {
					this.loading = false;
				}
			}
		}
	}
</script>